var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import { toDetail } from '../../helper/util';
import { EBillType } from '../../enum/EBillType';
import CommonService from '../../api/CommonService';
var ChatMessage = (function (_super) {
    __extends(ChatMessage, _super);
    function ChatMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.commonService = CommonService.getInstance();
        _this.shopOptions = [];
        _this.selectedShopId = null;
        return _this;
    }
    ChatMessage.prototype.created = function () {
        if (this.message.contentType === 'select' && this.message.content.type === 1) {
            this.loadShopData();
        }
    };
    ChatMessage.prototype.loadShopData = function () {
        var _this = this;
        this.commonService.getShopFilter({ type: 3, freeze: 0 }).then(function (res) {
            if (res.data.success) {
                _this.shopOptions = res.data.data || [];
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    ChatMessage.prototype.onShopSelect = function (node) {
        this.selectedShopId = node.id;
        var businessInfo = this.getBusinessInfo(node.id);
        var id = 0;
        if (this.message.content.type === 1) {
            id = 106;
        }
        else if (this.message.content.type === 2) {
            id = 107;
        }
        this.$emit('select-click', {
            type: 'click',
            click: {
                id: id,
                content: '选择订货门店',
                shop_id: node.id,
                shop_name: node.name,
                business_name: businessInfo.business_name,
                business_id: businessInfo.business_id
            }
        });
    };
    ChatMessage.prototype.getBusinessInfo = function (shopId) {
        var businessInfo = {
            business_name: '',
            business_id: ''
        };
        (this.shopOptions || []).forEach(function (business) {
            if (business.children) {
                business.children.forEach(function (shop) {
                    if (shop.id == shopId) {
                        businessInfo.business_name = business.name;
                        businessInfo.business_id = business.id;
                    }
                });
            }
        });
        return businessInfo;
    };
    ChatMessage.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    ChatMessage.prototype.formatTime = function (timestamp) {
        var now = new Date();
        var messageTime = new Date(timestamp);
        var diffMinutes = Math.floor((now.getTime() - messageTime.getTime()) / (1000 * 60));
        if (diffMinutes < 1) {
            return '刚刚';
        }
        else if (diffMinutes < 60) {
            return diffMinutes + "\u5206\u949F\u524D";
        }
        else if (diffMinutes < 24 * 60) {
            var hours = Math.floor(diffMinutes / 60);
            return hours + "\u5C0F\u65F6\u524D";
        }
        else {
            var year = messageTime.getFullYear();
            var month = String(messageTime.getMonth() + 1).padStart(2, '0');
            var day = String(messageTime.getDate()).padStart(2, '0');
            var hour = String(messageTime.getHours()).padStart(2, '0');
            var minute = String(messageTime.getMinutes()).padStart(2, '0');
            return year + "-" + month + "-" + day + " " + hour + ":" + minute;
        }
    };
    ChatMessage.prototype.formatFileSize = function (bytes) {
        if (!bytes)
            return '';
        var sizes = ['B', 'KB', 'MB', 'GB'];
        var i = Math.floor(Math.log(bytes) / Math.log(1024));
        return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
    };
    ChatMessage.prototype.previewImage = function () {
        this.$emit('preview-image', this.getImageUrl(this.message.content));
    };
    ChatMessage.prototype.downloadFile = function () {
        this.$emit('download-file', this.message);
    };
    ChatMessage.prototype.onMenuClick = function (item) {
        this.$emit('menu-click', item);
    };
    ChatMessage.prototype.onLinkClick = function (content) {
        if (content.url) {
            window.open(content.url, '_blank');
            return;
        }
        this.$store.dispatch('updateHomeShow', false);
        if (content.type == 1) {
            var order_id = content.params.order_id;
            toDetail(EBillType.PurOrder, order_id, this);
        }
        else if (content.type == 2) {
            var order_id = content.params.order_id;
            toDetail(EBillType.ShopAfterSales, order_id, this);
        }
    };
    ChatMessage.prototype.getImageUrl = function (content) {
        return content.thumb_media_id || content;
    };
    ChatMessage.prototype.onImageClick = function (content) {
        var imgUrl = content.thumb_media_id || content;
        this.$emit('preview-image', imgUrl);
    };
    __decorate([
        Prop({ required: true })
    ], ChatMessage.prototype, "message", void 0);
    ChatMessage = __decorate([
        Component
    ], ChatMessage);
    return ChatMessage;
}(Vue));
export default ChatMessage;
